import { TeamMember } from '@/types'
import { Badge } from 'flowbite-react'
import Image from 'next/image'
import UserIcon from '@/public/images/icons/user.svg'
import { Session } from 'next-auth'

interface TeamMemberListProps {
  teamMember: TeamMember[]
  currentUser: Session['user']
}

export const TeamMemberList = ({
  teamMember,
  currentUser,
}: TeamMemberListProps) => {
  return (
    <>
      {teamMember.map((member) => (
        <div key={member.id} className="flex items-center space-x-2">
          <Image
            // TODO: Use member.avatar_url when available
            // src={member.avatar_url || UserIcon}
            src={UserIcon}
            alt=""
            className="w-10 h-10 rounded-full"
            width={40}
            height={40}
          />
          <p className="text-gray-900 text-sm flex-1">
            {member.name} {member.username === currentUser.username && '(you)'}{' '}
            <span className="text-gray-500 text-sm">@{member.username}</span>
            {member.role === 'leader' && (
              <Badge
                color="blue"
                className="text-xs font-medium rounded-md inline ml-2"
              >
                leader
              </Badge>
            )}
          </p>
        </div>
      ))}
    </>
  )
}
